// extracted by mini-css-extract-plugin
export default {"Home":"styles_Home__BebyX","Home__board":"styles_Home__board__7Sez-","Home__sidebar":"styles_Home__sidebar__NJzXH"};